<template>
  <div>
    <div class="side-header">
      <span class="mr5">{{ $t("tags.diagnosis_tags") }}</span>
      <span class="edit-btn cursor" @click.stop="openTagModelDisease()"
        >[{{ $t("_data.modify") }}]</span
      >
    </div>
    <div class="side-content">
      <!--       
      <div class="info-item clearfix">
        <span class="fl">{{ $t("tags.subject_diagnosis") }}：</span>
        <span class="edit-btn cursor" @click.stop="openTagModelDiagnosis()"
          >[{{ $t("_data.edit_tag") }}]</span
        >
        <span class="fr">{{ diagnosis_tags.diagnosis || "" }}</span>
      </div>
      <div class="info-item clearfix">
        <span class="fl">{{ $t("tags.subject_sideonset") }}：</span>
        <span class="fr">{{ diagnosis_tags.sideonset || "" }}</span>
        <span class="edit-btn cursor" @click.stop="openTagModelSideonset()"
          >[{{ $t("_data.edit_tag") }}]</span
        >
      </div> -->

      <div class="info-item clearfix">
        <span class="fl">{{ $t("tags.subject_staging") }}:</span>
        <span class="fr">{{ diagnosis_tags.hy_staging || "" }}</span>
      </div>
      <div class="info-item clearfix">
        <span class="fl">{{ $t("tags.subject_disease") }}:</span>
        <span class="fr"
          >{{ diagnosis_tags.course || "" }}{{ $t("_data.month") }}</span
        >
      </div>
      <div class="info-item clearfix">
        <span class="fl">{{ $t("tags.education") }}:</span>
        <span class="fr">{{ diagnosis_tags.education || "" }}</span>
      </div>

      <table>
        <thead>
          <tr>
            <th>MMSE</th>
            <th>MOCA</th>
            <th>HAMA</th>
            <th>HAMD</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ diagnosis_tags.mmse || "" }}</td>
            <td>{{ diagnosis_tags.moca || "" }}</td>
            <td>{{ diagnosis_tags.hama || "" }}</td>
            <td>{{ diagnosis_tags.hamd || "" }}</td>
          </tr>
        </tbody>
      </table>

      <table>
        <tr>
          <th rowspan="2">UPDRS</th>
          <th>I</th>
          <th>II</th>
          <th>III</th>
          <th>IV</th>
        </tr>
        <tr>
          <td>{{ diagnosis_tags.updrs1 || "" }}</td>
          <td>{{ diagnosis_tags.updrs2 || "" }}</td>
          <td>{{ diagnosis_tags.updrs3 || "" }}</td>
          <td>{{ diagnosis_tags.updrs4 || "" }}</td>
        </tr>
      </table>
    </div>

    <subject_diagnosis
      :tagsList="setTagOptionsDiagnosis"
      :selectedTags="selectedTagsDiagnosis"
      :showPopover="showPopoverDiagnosis"
      @closeTagsPopover="showPopoverDiagnosis = false"
      @addTagDiagnosis="addTagDiagnosis"
      @submitTagsDiagnosis="submitTagsDiagnosis"
    ></subject_diagnosis>

    <subject_sideonset
      :tagsList="setTagOptionsSideonset"
      :selectedTags="selectedTagsSideonset"
      :showPopover="showPopoverSideonset"
      @closeTagsPopover="showPopoverSideonset = false"
      @addTagSideonset="addTagSideonset"
      @submitTagsSideonset="submitTagsSideonset"
    ></subject_sideonset>

    <subject_disease
      :setTagOptionsHystaging="setTagOptionsHystaging"
      :diagnosis_tags="diagnosis_tags"
      :showPopover="showPopoverDisease"
      :subject_id="edit_subject.id"
      @closeTagsPopover="showPopoverDisease = false"
      @submitTagsDisease="submitTagsDisease"
    ></subject_disease>
  </div>
</template>
<script>
import subject_diagnosis from "./subject_diagnosis";
import subject_disease from "./subject_disease";
import subject_sideonset from "./subject_sideonset";

import {
  tag_diagnosis,
  tag_diagnosis_create,
  tag_diagnosis_update,
  tag_diagnosis_remove,
  tag_sideonset,
  tag_sideonset_create,
  tag_sideonset_update,
  tag_sideonset_remove,
  tag_hystaging,
  tag_hystaging_create,
  tag_hystaging_update,
  tag_hystaging_remove,
  subject_tags,
} from "@/api/api";

import { MessageBox, Loading } from "element-ui";

export default {
  components: {
    subject_diagnosis,
    subject_disease,
    subject_sideonset,
  },
  props: {
    edit_subject: {
      type: Object,
      default: function () {
        return {};
      },
    },
    diagnosis_tags: {
      type: Object,
      default: function () {
        return {
          diagnosis: "",
          course: "",
          hy_staging: "",
          sideonset: "",
          mmse: "",
          moca: "",
          hama: "",
          hamd: "",
          updrs1: "",
          updrs2: "",
          updrs3: "",
          updrs4: "",
          education: "",
        };
      },
    },
  },
  data() {
    return {
      //诊断 初存入固定标签+自定义，
      selectedTagsDiagnosis: "",
      setTagOptionsDiagnosis: [],
      showPopoverDiagnosis: false,
      //病程 “病程”：整数月（手动输）
      showPopoverDisease: false,

      //起病侧 标签内容：左侧、左侧-上肢、左侧-下肢、右侧、右侧-上肢、右侧-下肢、不明确、自定义
      selectedTagsSideonset: "",
      setTagOptionsSideonset: [],
      showPopoverSideonset: false,

      //Table: subject_hystaging “H-Y分期” 标签内容：标签内容：0、1、1.5、2、2.5、3、4、5
      setTagOptionsHystaging: [],
    };
  },

  mounted() {
    this.getTagOptionsDiagnosis();
    this.getTagOptionsSideonset();
    this.getTagOptionsHystaging();
    //监听键盘esc事件
    document.addEventListener("keyup", this.handleKeyup);
  },
  beforeDestroy() {
    //监听键盘esc事件
    document.removeEventListener("keyup", this.handleKeyup);
  },
  methods: {
    //监听键盘esc事件
    handleKeyup(event) {
      if (event.key === "Escape") {
        //console.log("Esc key pressed");
        this.showPopoverDiagnosis = false;
        this.showPopoverSideonset = false;
        this.showPopoverDisease = false;
      }
    },
    //诊断标签

    async getTagOptionsDiagnosis() {
      try {
        let res = await tag_diagnosis();
        if (res.status === 200) {
          this.setTagOptionsDiagnosis = res.data.length > 0 ? res.data : [];
        }
      } catch (error) {}
    },
    //起病侧标签
    async getTagOptionsSideonset() {
      try {
        let res = await tag_sideonset();
        if (res.status === 200) {
          this.setTagOptionsSideonset = res.data.length > 0 ? res.data : [];
        }
      } catch (error) {}
    },
    //“H-Y分期”
    async getTagOptionsHystaging() {
      try {
        let res = await tag_hystaging();
        if (res.status === 200) {
          this.setTagOptionsHystaging = res.data.length > 0 ? res.data : [];
        }
      } catch (error) {}
    },
    openTagModelDiagnosis() {
      this.selectedTagsDiagnosis = this.diagnosis_tags.diagnosis || "";
      this.showPopoverDiagnosis = true;
    },
    //添加自定义诊断标签
    async addTagDiagnosis(tagName) {
      if (!tagName) {
        this.$helper.warningMessage(this.$t("notice.tag_name_required"));
        return false;
      }

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        name: tagName,
      };
      try {
        let res = await tag_diagnosis_create(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getTagOptionsDiagnosis();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    //保存诊断标签
    async submitTagsDiagnosis(tagname) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        subject_id: this.edit_subject.id,
        diagnosis: tagname, // 字段名： diagnosis
      };
      try {
        let res = await subject_tags(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.showPopoverDiagnosis = false;
          this.edit_subject.diagnosis_tags.diagnosis = tagname;
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        this.$helper.errNotify(error.message);
        loadingInstance.close();
      }
    },

    //诊断标签
    openTagModelDisease() {
      this.showPopoverDisease = true;
    },
    //保存诊断标签
    async submitTagsDisease(tags) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        subject_id: this.edit_subject.id,
        course: tags.course, // 字段名： course
        hy_staging: tags.hy_staging,
        mmse: tags.mmse,
        moca: tags.moca,
        hama: tags.hama,
        hamd: tags.hamd,
        updrs1: tags.updrs1,
        updrs2: tags.updrs2,
        updrs3: tags.updrs3,
        updrs4: tags.updrs4,
        education: tags.education,
      };

      try {
        let res = await subject_tags(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.showPopoverDisease = false;
          this.edit_subject.diagnosis_tags = Object.assign(
            {},
            this.edit_subject.diagnosis_tags,
            tags
          );
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        this.$helper.errNotify(error.message);
        loadingInstance.close();
      }
    },

    //H-Y分期
    //保存H-Y分期:0，1，1.5，2，2.5，3，4，5
    async submitTagsStaging(tagname) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        subject_id: this.edit_subject.id,
        hy_staging: tagname, // 字段名： course
      };

      try {
        let res = await subject_tags(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.showPopoverStaging = false;
          this.edit_subject.diagnosis_tags.hy_staging = tagname;
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        this.$helper.errNotify(error.message);
        loadingInstance.close();
      }
    },

    //起病侧
    openTagModelSideonset() {
      this.selectedTagsSideonset = this.diagnosis_tags.sideonset || "";
      this.showPopoverSideonset = true;
    },

    //添加自定义起病侧标签
    async addTagSideonset(tagName) {
      if (!tagName) {
        this.$helper.warningMessage(this.$t("notice.tag_name_required"));
        return false;
      }

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        name: tagName,
      };
      try {
        let res = await tag_sideonset_create(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getTagOptionsSideonset();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    //保存起病侧 标签内容：左侧、左侧-上肢、左侧-下肢、右侧、右侧-上肢、右侧-下肢、不明确、自定义
    async submitTagsSideonset(tagname) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        subject_id: this.edit_subject.id,
        sideonset: tagname,
      };
      try {
        let res = await subject_tags(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.showPopoverSideonset = false;
          this.edit_subject.diagnosis_tags.sideonset = tagname;
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        this.$helper.errNotify(error.message);
        loadingInstance.close();
      }
    },
  },
};
</script>



<style lang="less" scoped>
.info-side {
  width: 290px;
  position: sticky;
  top: 0;
  margin-bottom: 20px;
  .side-header {
    margin-bottom: 10px;
  }
  .edit-btn {
    color: #067afd;
  }
  .side-content {
    border-radius: 3px;
    background: #fff;
    box-shadow: 1px 1px 1px 2px #f2f2f2;
  }
  .info-item {
    padding: 7px 10px;
    border-bottom: 1px solid #dfdfdf;
    color: #6c757d;
    &:last-child {
      border-bottom: none;
    }
  }
  .diagnostic {
    padding: 5px 10px;
    max-height: 100px;
    border: 1px solid #bfbfc1;
    overflow-y: auto;
  }

  /* 设置表格网格线样式 */
  table {
    border-collapse: collapse;
    width: 100%;
    margin: 8px 0;
  }

  th,
  td {
    border: 1px solid #eee;
    padding: 8px;
    text-align: center;
  }

  th {
    background-color: #f2f2f2;
  }
}
</style>